<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-6 ts-space-y-1">
          <div class="row">
            <div class="col-md-12">
              <label class="col-md-12 col-form-label required">
                {{ $t('invoice.mainProgram') }}
              </label>
              <div class="col-md-12">
                <a-select
                  v-model="model.acp_id"
                  class="ts-w-full"
                  :options="mainProgramsOpt"
                  @change="onMainProgramChange"
                  :showSearch="true"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                ></a-select>
                <div class="validate" v-if="errors.has('acp_id')">
                  {{ errors.first('acp_id') }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="col-md-12 col-form-label required">
                {{ $t('invoice.subProgram') }}
              </label>
              <div class="col-md-12">
                <a-select
                  v-model="model.acps_id"
                  class="ts-w-full"
                  :options="subProgramOpt"
                  @change="onSubProChange"
                  :showSearch="true"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                ></a-select>
                <div class="validate" v-if="errors.has('acps_id')">
                  {{ errors.first('acps_id') }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="col-md-12 col-form-label required">
                {{ $t('invoice.acTerm') }}
              </label>
              <div class="col-md-12">
                <a-select
                  v-model="model.ac_term_id"
                  class="ts-w-full"
                  :options="academicTermOpt"
                  :showSearch="true"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  @change="onAcademicTermChange"
                ></a-select>
                <div class="validate" v-if="errors.has('ac_term_id')">
                  {{ errors.first('ac_term_id') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 ts-space-y-1">
          <div class="row">
            <div class="col-md-12">
              <label class="col-md-12 col-form-label required">
                {{ $t('invoice.level') }}
              </label>
              <div class="col-md-12">
                <a-select
                  v-model="model.level_id"
                  class="ts-w-full"
                  :options="levelOpt"
                  :showSearch="true"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  @change="onLevelChange"
                ></a-select>
                <div class="validate" v-if="errors.has('level_id')">
                  {{ errors.first('level_id') }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="col-md-12 col-form-label required">
                {{ $t('invoice.grade') }}
              </label>
              <div class="col-md-12">
                <a-select
                  v-model="model.grade_id"
                  class="ts-w-full"
                  :options="gradeOpt"
                  :showSearch="true"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                ></a-select>
                <div class="validate" v-if="errors.has('grade_id')">
                  {{ errors.first('grade_id') }}
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <label class="col-md-12 col-form-label required">
                {{ $t('invoice.studyTime') }}
              </label>
              <div class="col-md-12">
                <a-select
                  v-model="model.study_time"
                  class="ts-w-full"
                  :options="studyTimeOpt"
                  :showSearch="true"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                ></a-select>
                <div class="validate" v-if="errors.has('study_time')">
                  {{ errors.first('study_time') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
export default {
  name: 'academicForNoEnroll',
  props: ['value', 'validate'],
  data() {
    return {
      model: {},
      loading: false,
      errors: new Errors(),
      mainProgram: [],
      subProgram: [],
      academicTerm: [],
      level: [],
      grade: [],
      studyTime: []
    }
  },
  created() {
    this.model = this.value
    this.getFormModel({
      fnName: 'mainProgram,studyTime'
    })
  },
  computed: {
    mainProgramsOpt() {
      return this.mainProgram.map(el => ({
        value: el.acp_id,
        label: el.acp_name_foreign
      }))
    },
    subProgramOpt() {
      return this.subProgram.map(el => ({
        value: el.acps_id,
        label: el.acps_name_foreign
      }))
    },
    academicTermOpt() {
      return this.academicTerm.map(el => ({
        value: el.ac_term_id,
        label: `${el.term_name}(${
          el.ac_status_id === 1 ? 'current' : 'next'
        })-${el.ac_year}`,
        title: `${el.term_name}(${
          el.ac_status_id === 1 ? 'current' : 'next'
        })-${el.ac_year}`,
        ac_year_id: el.ac_year_id,
        term_start: el.term_start,
        term_stop: el.term_stop
      }))
    },
    levelOpt() {
      return this.level.map(el => ({
        value: el.level_id,
        label: el.level_name_foreign
      }))
    },
    gradeOpt() {
      return this.grade.map(el => ({
        value: el.grade_id,
        label: el.grade_name_foreign
      }))
    },
    studyTimeOpt() {
      return this.studyTime.map(el => ({
        value: el.study_time,
        label: el.study_time
      }))
    }
  },
  methods: {
    ...mapActions('invoiceForNoEnroll', ['formViewModel']),
    getFormModel(attributes) {
      this.loading = true
      this.formViewModel(attributes)
        .then(response => {
          attributes.fnName.split(',').forEach(fn => {
            this[fn] = response.data[fn]
          })
        })
        .finally(() => (this.loading = false))
    },
    onMainProgramChange(acpId) {
      this.model.acps_id = null
      this.model.ac_term_id = null
      this.model.grade_id = null
      this.subProgram = []
      this.academicTerm = []
      this.level = []
      this.grade = []
      this.getFormModel({
        fnName: 'subProgram',
        acp_id: acpId
      })
    },
    onSubProChange(acpsId) {
      this.model.ac_term_id = null
      this.model.grade_id = null
      this.academicTerm = []
      this.level = []
      this.grade = []
      this.getFormModel({
        fnName: 'academicTerm,level',
        acps_id: acpsId
      })
    },
    onLevelChange(levelId) {
      this.model.grade_id = null
      this.grade = []
      this.getFormModel({
        fnName: 'grade',
        level_id: levelId
      })
    },
    onAcademicTermChange(value, opt) {
      this.model.ac_year_id = opt.data.props.ac_year_id
      this.model.ac_term_stop_date = opt.data.props.term_stop
      this.model.ac_term_start_date = opt.data.props.term_start 
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
